<script>
  export let armorIcon;
  export let isSelected = false;
  export let isDisabled = false;
  export let onHover = () => {return () => {}};
  export let onClick = () => {};
  export let onRightClick = () => {};
  let onMouseLeave = () => {};
</script>

<button class={`armor-item${isSelected ? ' selected' : ''}${isDisabled ? ' disabled' : ''}`}
  on:mouseenter={(e) => {
    onMouseLeave = onHover(e) || onMouseLeave;
  }}
  on:mouseleave={(e) => {
    onMouseLeave(e);
  }}
  on:click={onClick}
  on:contextmenu={onRightClick}
>
  <img class="armor-icon" src={armorIcon} alt="Icon of armor or night-vision goggles"/>
</button>

<style>
  .armor-item {
    padding: 1.2em 1.2em;
    margin: 1px 0;
    width: 100%;
    height: 145px;
  }

  .armor-icon {
    max-width: 80px;
  }

  .armor-item.selected {
    background: rgba(47, 47, 47, 0.75);
    border-left: 10px solid #22BA3A;
  }

  .armor-item.disabled img {
    opacity: 0.35;
  }
</style>